import { log } from 'node:console';
import { SiteMap } from '../../../services/content';
import { TyNavMenuMap, TyLink } from '../../../types';
import { unwrapActionList } from '../../../utils/unwrapCSComponentModels';
import { IHeaderProps } from './IHeader';

export function contentToHeader(content: any) {
  const newMenuBlocks: any = {};
  const navToolbarMap: any = {};
  let regionMessages: any;
  let regions: any = [];
  let topToolBarMap: any = {};

  if (!content.page) return;
  const SITE_MAP_LINK = content?.siteMap?.[SiteMap.SITE_MAP_LINK] || [];

  // Main Navigation Menu Blocks
  content?.header?.main_navigation_menu?.forEach((main_nav_item: any) => {
    main_nav_item.navigation_blocks?.forEach(
      (menuItem: any, index: any) => {
        if (menuItem.hasOwnProperty('navigation_link')) {
          newMenuBlocks[menuItem.navigation_link?.header_link[0]?.title] =
            menuItem.navigation_link?.header_link?.map((link: any) => ({
              menu: false,
              data: {
                title: link.title,
                label: link.internal_link_url?.title,
                href: (link.isexternallink && link.external_url )? link.external_url.href : SITE_MAP_LINK[link.internal_link_url?.site_url[0]?.uid]?.url,
                isRegionHeaderLink: link.isregionheaderlink,
                showOnlyAfterLogin: link.showonlyafterlogin,
                isexternallink: link.isexternallink ?  link.isexternallink :  SITE_MAP_LINK[link.internal_link_url?.site_url[0]?.uid]?.isExternal,
              },
            }));
        }
        if (menuItem.hasOwnProperty('menu')) {
          newMenuBlocks[menuItem.menu.navigation_header_text] = menuItem.menu.menu_columns.map(
            (column: any) => ({
              menu: true,
              data: column.sub_nav_links.map((link: any) => ({
                label: link.display_text,
                href: SITE_MAP_LINK[link.internal_site_url[0]?.uid]?.url,
              })),
            }),
          );
        }
      },
    );
  });
  /**  Navigation toolbar
   * 1.Region
   * 2.Top header toolbar
   */
  content?.header?.top_navigation_toolbar?.forEach((menuItem: any, index: any) => {
    if (menuItem.hasOwnProperty('region_picker')) {
      regionMessages = menuItem?.region_picker?.kp_regions?.regional_messages;
      regions = menuItem?.region_picker?.kp_regions?.regions.value;
    }
    if (menuItem.hasOwnProperty('tool_bar')) {
      menuItem.tool_bar.toolbar_links.map((actions: any, index: any) =>
        actions.items.forEach((link: any) => {
          if (link.hasOwnProperty('action')) {
            topToolBarMap[link?.action?.component_id] = {
              label: link?.action?.label,
              path: SITE_MAP_LINK[link?.action?.action[0]?.uid]?.url,
              background: link?.action?.background,
              displayrule: link?.action?.displayrule,
              icon: link?.action?.icon,
              showOnlyAfterLogin: link?.action?.displayrule,
              isexternallink: SITE_MAP_LINK[link?.action?.action[0]?.uid]?.isExternal,
            };
          } else if (link.hasOwnProperty('select_list')) {
            link?.select_list?.list.forEach((item: any, index: any) => {
              if (item.hasOwnProperty('kp_regions') && item._content_type_uid) {
                topToolBarMap[item._content_type_uid] = item.kp_regions;
              } else if (item.hasOwnProperty('navigation_blocks')) {
                item?.navigation_blocks?.forEach((subMenu: any, index: any) => {
                  if (subMenu.hasOwnProperty('menu') && item._content_type_uid) {
                    topToolBarMap[item._content_type_uid] = subMenu.menu.menu_columns.map(
                      (column: any) => ({
                        menu: true,
                        label: subMenu.menu.navigation_header_text,
                        data: column.sub_nav_links.map((link: any) => ({
                          label: link.display_text,
                          href: SITE_MAP_LINK[link.internal_site_url[0]?.uid]?.url,
                          icon: link?.icons,
                        })),
                      }),
                    );
                  }
                });
              }
            });
          }
        }),
      );
    }
  });
  navToolbarMap['topToolbar'] = topToolBarMap;
  /**  Navigation toolbar
   * Register toolbar
   */
  content?.header?.middle_navigation_toolbar?.forEach((menuItem: any, index: any) => {
    if (menuItem.hasOwnProperty('toolbar')) {
      navToolbarMap['signoutToolbar'] = menuItem.toolbar.toolbar_links.map((actions: any) =>
        actions.items.map((link: any) => ({
          label: link?.action?.label,
          path: SITE_MAP_LINK[link?.action?.action[0]?.uid]?.url,
          background: link?.action?.background,
          displayrule: link?.action?.displayrule,
          icon: link?.action?.icon,
          showOnlyAfterLogin: link?.action?.displayrule,
          isexternallink: SITE_MAP_LINK[link?.action?.action[0]?.uid]?.isExternal,
          componentId: link?.action?.component_id,
        })),
      );
    }
  });

  // Navigation Links
  const navLinks: TyLink[] = content.header?.navigation_links?.map((link: any) => ({
    title: link.title, // remove title when creating separate region picker component
    label: link.internal_link_url?.title,
    href: SITE_MAP_LINK[link.internal_link_url?.site_url[0]?.uid]?.url,
    isRegionHeaderLink: link.isregionheaderlink,
    showOnlyAfterLogin: link.showonlyafterlogin,
    isexternallink: SITE_MAP_LINK[link.internal_link_url?.site_url[0]?.uid]?.isExternal,
  }));

  // Navigation toolbar
  const toolbar: any = {};
  const notificationErrorsMsg = content.header?.web_notifications?.error_message.messages.map(
    (item: any) => {
      return {
        heading: item.content.heading,
        desc: item.content.message,
        errorCode: item.alert_code,
      };
    },
  );

  const searchBar = () => {
    let searchMap: any = {};
    const search = content.header?.search_bar;
    if (search) {
      searchMap['popular_search'] = search.popular_search?.search_options?.map((link: any) => {
        return {
          search_name: link.search_name,
          href: SITE_MAP_LINK[link?.search_page[0]?.uid]?.url,
          isexternallink: SITE_MAP_LINK[link.search_page[0]?.uid]?.isExternal,
        };
      });
      const search_button = search?.simple_search?.search_button;
      if (search_button) {
        searchMap['simple_search'] = {
          href: SITE_MAP_LINK[search_button.page[0].uid]?.url,
          isexternallink: SITE_MAP_LINK[search_button.page[0].uid]?.isExternal,
          title: search_button.title
        };
      }
      searchMap['help_text'] = search.simple_search?.help_text;
      searchMap['search_title'] = search.popular_search?.search_title;
    }

    return searchMap;
  };

  const headerProps: IHeaderProps = {
    siteLogo: {
      url: content.header?.logo?.url,
      alt: content.header?.logo?.alt,
    },
    navLinks,
    toolbar,
    regionMessages,
    newMenuBlocks,
    navToolbarMap,
    notificationErrorsMsg,
    regions,
    siteSearch: searchBar(),
  };
  return headerProps;
}
